import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AppContainer from "../Appcontainer";
import store from "../../store";
import { Provider } from "react-redux";
import Login from "../../views/pages/Authentication/Login";
import Register from "../../views/pages/Authentication/Register";
import Otp from "../../views/pages/Authentication/Otp";
import Error404 from "../../views/pages/Error/Error404";
import Error500 from "../../views/pages/Error/Error500";
import JobList from "../../views/pages/Authentication/JobList";
import JobView from "../../views/pages/Authentication/JobView";
import ChangePassword from "../../views/pages/Authentication/ChangePassword";
import ForgotPassword from "../../views/pages/Authentication/ForgotPassword";
import LockScreen from "../../views/pages/Authentication/LockScreen";
import Accordions from "../../views/pages/Ui_Interface/Components/Accordions";
import Alerts from "../../views/pages/Ui_Interface/Components/Alerts";
import Breadcrumbs from "../../views/pages/Ui_Interface/Components/Breadcrumbs";
import Avatar from "../../views/pages/Ui_Interface/Components/Avatar";
import Badges from "../../views/pages/Ui_Interface/Components/Badges";
import ButtonCard from "../../views/pages/Ui_Interface/Components/ButtonCard";
import ButtonGroup from "../../views/pages/Ui_Interface/Components/ButtonGroup";
import Cards from "../../views/pages/Ui_Interface/Components/Cards";
import Dropdowns from "../../views/pages/Ui_Interface/Components/Dropdowns";
import Grid from "../../views/pages/Ui_Interface/Components/Grid";
import Images from "../../views/pages/Ui_Interface/Components/Images";
import Media from "../../views/pages/Ui_Interface/Components/Media";
import Modals from "../../views/pages/Ui_Interface/Components/Modals";
import Offcanvas from "../../views/pages/Ui_Interface/Components/Offcanvas";
import Pagination from "../../views/pages/Ui_Interface/Components/Pagination";
import Popover from "../../views/pages/Ui_Interface/Components/Popover";
import Progress from "../../views/pages/Ui_Interface/Components/Progress";
import Placeholder from "../../views/pages/Ui_Interface/Components/Placeholder";
import RangeSlider from "../../views/pages/Ui_Interface/Components/RangeSlider";
import Spinners from "../../views/pages/Ui_Interface/Components/Spinners";
import SweetAlert from "../../views/pages/Ui_Interface/Components/SweetAlert";
import Tabs from "../../views/pages/Ui_Interface/Components/Tabs";
import Toats from "../../views/pages/Ui_Interface/Components/Toats";
// import Tooltip from "../../views/pages/Ui_Interface/Components/Tooltip";
import Typography from "../../views/pages/Ui_Interface/Components/Typography";
import Videos from "../../views/pages/Ui_Interface/Components/Videos";
import Lightbox from "../../views/pages/Ui_Interface/Components/Lightbox";
import Carousel from "../../views/pages/Ui_Interface/Components/Carousel";
// import { Navigate } from "react-router-dom/dist";
import Borders from "../../views/pages/Ui_Interface/Components/Borders";
import Breadcrumb from "../../views/pages/Ui_Interface/Components/Breadcrumb";
import Colors from "../../views/pages/Ui_Interface/Components/colors";
import UiModals from "../../views/pages/Ui_Interface/Components/uimodals";
import Spinner from "../../views/pages/Ui_Interface/Components/Spinner";
import Tooltips from "../../views/pages/Ui_Interface/Components/Tooltip";
import ComingSoon from "../../views/pages/Pages/ComingSoon";
import UnderManitenance from "../../views/pages/Pages/UnderManitenance";
import LoginWithMobile from "../../views/pages/MainPages/Dashboard/AdminDashboard/LoginWithMobile";
import ResetPassword from "../../views/pages/Authentication/ResetPassword";
import RolesPage from "../../roles/RolesPage";
import PropertyVisit from "../../views/pages/Performance/Goals/PropertyVisit";
import VendorVisit from "../../views/pages/Performance/Goals/VendorVisit";
// import { AuthProvider } from "../../authContext/AuthProvider";
import PrivateRoute from "../../PrivateRoutes/PrivateRouute";
// import AdminDashboard from "../../views/pages/MainPages/Dashboard/AdminDashboard/adminDashboard";
import { AuthProvider } from "../../Context/AuthContext";
import AddBusinessPd from "../../views/pages/Employees/AddBusinessPd";
import BuisnessPDList from "../../views/pages/Employees/BuisnessPDList";
import BuisnessPD from "../../views/pages/Employees/BuisnessPD";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivacyPolicy from "../../views/pages/Pages/PrivacyPolicy";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    // checkCurrentUser();
  }, [pathname]);
};

const AppRouter = () => {
  return (
    <div>
      <Provider store={store}>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/loginwithmobile" element={<LoginWithMobile />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route
                path="/reset-password/:email/:temptoken"
                element={<ResetPassword />}
              />
              <Route path="/otp" element={<Otp />} />
              <Route element={<PrivateRoute />}>
                <Route path="/roles" element={<RolesPage />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/propertyvisit" element={<PropertyVisit />} />
                <Route path="/vendorvisit" element={<VendorVisit />} />
                <Route path="/error-404" element={<Error404 />} />
                <Route path="/error-500" element={<Error500 />} />
                <Route path="/*" element={<AppContainer />} />
              </Route>
            </Routes>
            <ToastContainer />
          </BrowserRouter>
        </AuthProvider>
      </Provider>
    </div>
  );
};

export default AppRouter;
